const ANY_ORIGIN = '*';

export function parseHvmOrigins(value) {
  return (value || '')
    .split(',')
    .map(item => item.trim().replace(/\/+$/, ''))
    .filter(Boolean);
}

/**
 * Where the HVM message may go. The answers are personal data, so once the HVM origins are configured
 * (`REACT_APP_HVM_ORIGINS`, comma separated) the message is posted to each of them: the browser delivers it only
 * when the embedding page has that origin, so no other parent gets it. Without the setting the message keeps going
 * to any parent, as before.
 */
export function getHvmTargetOrigins(allowedOrigins = parseHvmOrigins(process.env.REACT_APP_HVM_ORIGINS)) {
  return allowedOrigins.length === 0 ? [ANY_ORIGIN] : allowedOrigins;
}
